module.exports = __webpack_public_path__ + "img/nr.2526a443.svg";